import { api } from "../App";
import { createNotification } from "../components/Notifications/Notifications";
import { SET_EVENT_LEVELS_LOADING, SET_HOLIDAYS_LIST } from "./types";


export const getHolidays = () => async (dispatch) => {
  try {
    const { data } = await api.get('/all_holidays');
    dispatch({ type: SET_HOLIDAYS_LIST, payload: data });
  } catch (ERR) {
  }
}

export const createHolidays = (reqData, closeModal) => async (dispatch) => {
  let success;
  try {
    dispatch({ type: SET_EVENT_LEVELS_LOADING, payload: true });
    await api.post(`/all_holidays`, reqData);
    success = true;
    createNotification('success', 'Успешно');
    await dispatch(getHolidays());
    closeModal();
  } catch (error) {
    const errorMessage = error.response?.data?.error || 'Не удалось создать запись';
    createNotification('error', errorMessage);
  } finally {
    dispatch({ type: SET_EVENT_LEVELS_LOADING, payload: false });
    return success;
  }
}

export const updateHolidays = ({ hid, ...reqData }, closeModal) => async (dispatch) => {
  let success;
  try {
    dispatch({ type: SET_EVENT_LEVELS_LOADING, payload: true });
    await api.put(`/all_holidays/${hid}`, reqData);
    success = true;
    createNotification('success', 'Успешно');
    await dispatch(getHolidays());
    closeModal();
  } catch (error) {
    const errorMessage = error.response?.data?.error || 'Не удалось изменить запись';
    createNotification('error', errorMessage);
  } finally {
    dispatch({ type: SET_EVENT_LEVELS_LOADING, payload: false });
    return success;
  }
}

export const deleteHolidays = (id) => async (dispatch) => {
  try {
    dispatch({ type: SET_EVENT_LEVELS_LOADING, payload: true });
    await api.delete(`/all_holidays/${id}`);
    await dispatch(getHolidays());
    createNotification('success', 'Успешно');
  } catch (ERR) {
    createNotification('error', 'Не удалось изменить запись');
  } finally {
    dispatch({ type: SET_EVENT_LEVELS_LOADING, payload: false });
  }
}
